import { BookingOptionRequest, Option, OptionDefinitionCompressedTypeEnum } from '@jooxter/api';
import { IOptionChoice } from './types';

/** The space's options, each on when mandatory or on by default, with its default value. */
export const getInitialOptionChoices = (options: Option[]): IOptionChoice[] =>
  options
    .filter((option): option is Option & { id: number } => option.id !== undefined && option.available !== false)
    .map((option) => ({
      id: option.id,
      name: option.definition?.name ?? '',
      type: option.definition?.type ?? OptionDefinitionCompressedTypeEnum.Checkbox,
      possibleValues: option.definition?.possibleValues ?? [],
      mandatory: !!option.mandatory,
      activated: !!option.mandatory || !!option.selectedByDefault,
      value: option.defaultValue ?? '',
    }));

/** A mandatory option must be on and, unless it is a plain checkbox, have a value. */
export const isOptionChoiceValid = (choice: IOptionChoice): boolean =>
  !choice.mandatory ||
  (choice.activated && (choice.type === OptionDefinitionCompressedTypeEnum.Checkbox || !!choice.value.trim()));

/** The options on, as the booking request sends them. */
export const toBookingOptionRequests = (choices: IOptionChoice[]): BookingOptionRequest[] =>
  choices
    .filter((choice) => choice.activated)
    .map((choice) => ({ optionOverloadedId: choice.id, value: choice.value }));
